var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13C10.75 12.5858 10.4142 12.25 10 12.25C9.58579 12.25 9.25 12.5858 9.25 13V14.5C9.25 14.9142 9.58579 15.25 10 15.25C10.4142 15.25 10.75 14.9142 10.75 14.5V13Z",
    fill: "#808085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C12.6234 2.5 14.75 4.62665 14.75 7.25V9H15C16.1046 9 17 9.89543 17 11V16.5C17 17.6046 16.1046 18.5 15 18.5H5C3.89543 18.5 3 17.6046 3 16.5V11C3 9.89543 3.89543 9 5 9H5.25V7.25C5.25 4.62665 7.37665 2.5 10 2.5ZM13.25 7.25V9H6.75V7.25C6.75 5.45507 8.20507 4 10 4C11.7949 4 13.25 5.45508 13.25 7.25ZM5 10.5C4.72386 10.5 4.5 10.7239 4.5 11V16.5C4.5 16.7761 4.72386 17 5 17H15C15.2761 17 15.5 16.7761 15.5 16.5V11C15.5 10.7239 15.2761 10.5 15 10.5H5Z",
    fill: "#808085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.23bfb4fc.svg";
export { ForwardRef as ReactComponent };